import PhotoGrid from '../components/PhotoGrid'
import SeoHead from '../components/SeoHead'

const SLOTS = Array.from({ length: 12 }, () => ({ caption: null }))

export default function ArtGallery() {
  return (
    <>
      <SeoHead
        title="St. Clair Art Gallery — East County Business Center"
        description="The St. Clair Art Gallery at East County Business Center showcases local San Diego-area artists, bringing creativity into our El Cajon coworking space."
        path="/news/art-gallery"
      />
      <section className="bg-ecbc-navy text-white py-20 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">St. Clair Art Gallery</h1>
        <p className="text-white/75 max-w-2xl mx-auto text-lg">
          The St. Clair Art Gallery celebrates local artists by bringing creativity into the workplace. Artwork is displayed throughout the building and rotates periodically.
        </p>
      </section>

      <section className="bg-white py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <PhotoGrid slots={SLOTS} />

          <div className="mt-10 text-center">
            <p className="text-gray-600">
              Interested in displaying your work at ECBC? Email us at{' '}
              <a href="mailto:info@eastcountybiz.com" className="text-ecbc-navy font-semibold hover:underline">
                info@eastcountybiz.com
              </a>.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
